import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';

@Injectable()
export class IsLoggedIn implements CanActivate {
  constructor(private UserService: UserService, private router: Router) { }

  canActivate() {
    if (!this.UserService.isLoggedIn()) {
      this.router.navigate(['/']);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/is-logged-in.ts